
import React, { useEffect, useState } from "react";
import { Button, DatePicker, Modal, Select, Space, Input, Form } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Option } from "antd/es/mentions";
dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;

export const  AppoinmentsFilter = ({ form, isModalOpen, handleCancel, setFilterForm, filterForm, handleFilter }) => {


  return (
    <>
      <Modal
        title="Filters"
        open={isModalOpen}
        onOk={handleFilter}
        okText={"Filter Data"}
        onCancel={handleCancel}
      >
        <Form form={form} layout="vertical" >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
              marginTop: "20px",
            }}
          >
            <Form.Item
              name="salonName"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the salon name!" },
              ]}
            >
              <Input value={filterForm?.salonName} onChange={(e) => setFilterForm({ ...filterForm, salonName: e.target.value })} size="large" placeholder="filter by  salon name" />
            </Form.Item>

            <Form.Item
              name="serviceName"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the service name!" },
              ]}
            >
              <Input value={filterForm?.serviceName} onChange={(e) => setFilterForm({ ...filterForm, serviceName: e.target.value })} size="large" placeholder="filter by  service name" />
            </Form.Item>

  
        
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <Form.Item
              name="status"
              className="subscription-plan"
            >
              <Select
                value={filterForm?.status}
                onChange={(value) => setFilterForm({ ...filterForm, status: value })}
                placeholder="filter by status"
                style={{
                  marginTop: "0.5rem",
                  width: "99%",
                }}
                options={[
                  {
                    value: "0",
                    label: "InActive",
                  },
                  {
                    value: "1",
                    label: "Active",
                  },
                ]}
              />
            </Form.Item>

            <Form.Item
              name="visitType"
              className="subscription-plan"
            >
              <Select
                placeholder="filter by  visit type"
                value={filterForm?.visitType}
                onChange={(value) => setFilterForm({ ...filterForm, visitType: value })}
                style={{
                  marginTop: "0.5rem",
                  width: "99%",
                }}
              >
                <Option value="0">
                  Home
                </Option>
                <Option value="1">
                  Salon
                </Option>
                <Option value="2">
                  Both
                </Option>
              </Select>
            </Form.Item>
          </div>
           {/* <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "20px",
                      }}
                    >
            <Form.Item
                        name="bookingDate"
                        className="subscription-plan"
                        rules={[
                          { required: true, message: "Please enter the booking fromdate!" },
                        ]}
                      >
                        <Input value={filterForm?.bookingfromDate} onChange={(e) => setFilterForm({ ...filterForm, name: e.target.value })} size="large" placeholder="filter by booking fromdate" />
                      </Form.Item>
                      <Form.Item
                        name="bookingDate"
                        className="subscription-plan"
                        rules={[
                          { required: true, message: "Please enter the booking todate!" },
                        ]}
                      >
                        <Input value={filterForm?.bookingtoDate} onChange={(e) => setFilterForm({ ...filterForm, name: e.target.value })} size="large" placeholder="filter by booking todate" />
                      </Form.Item>
                    
          
                    </div> */}
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
                    <Form.Item
              name="salonType"
              className="subscription-plan"
            >
              <Select
                placeholder="filter by  salon type"
                value={filterForm?.salonType}
                onChange={(value) => setFilterForm({ ...filterForm, salonType: value })}
                style={{
                  marginTop: "0.5rem",
                  width: "99%",
                }}
              >
                <Option value="0">
                  Male
                </Option>
                <Option value="1">
                  Female
                </Option>
                <Option value="2">
                  Both
                </Option>
              </Select>
            </Form.Item>

         
          </div> */}
          <div>
            <Space direction="vertical" size={12} style={{ marginBottom: "20px" }}>
              {/* <RangePicker disabledDate={disabledDate} /> */}
            </Space>
          </div>
        </Form>
      </Modal>
    </>
  );
};
